import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {BottomSheet} from '~library/molecules/BottomSheet';
import {ResponsivePanel} from '~library/organisms/ResponsivePanel';
import {mediumAndUpQuery} from '~libSass/base/_exports.sass';
import {OverlayContent} from './components/OverlayContent';
import './ThemePickerOverlay.sass';

export const ThemePickerOverlay = ({closeOverlay, isOpen}) => {
  const {matches: isDesktop} = useMatchQuery(`(${mediumAndUpQuery})`);

  return isDesktop ? (
    <ResponsivePanel
      isOpen={isOpen}
      onClose={closeOverlay}
      title="Change theme"
      modalId="theme-picker"
      closeQaId="sheet-theme-picker-exit"
      showCover
      className="EviteModal__Content-HalfPage"
    >
      <OverlayContent />
    </ResponsivePanel>
  ) : (
    <BottomSheet
      in={isOpen}
      content={<OverlayContent handleClose={closeOverlay} />}
      onClose={closeOverlay}
      className="theme-picker-overlay__bottom-sheet"
    />
  );
};
